import { graphql } from '../generated';

export const CREATE_WORKSPACE = graphql(`
  mutation CreateWorkspace($input: CreateWorkspaceInput!) {
    createWorkspace(input: $input) {
      workspace {
        ...WorkspaceFields
      }
      userErrors {
        code
        field
        message
      }
    }
  }
`);
